module.exports = __webpack_public_path__ + "static/media/bellNotif.d8653ed1.wav";